/*
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

// @todo Enable two quiz templates when the interactivity is added to the web story editor.
// Assets and Stickers for these templates have already been added, to enable these template add them to
// the TEMPLATE_NAMES array.
// Templates need to be added:
//   1. 'beauty-quiz',
//   2. 'sports-quiz',
// See https://github.com/google/web-stories-wp/issues/8725 for more details.

export const TEMPLATE_NAMES = [
  'fresh-and-bright',
  'food-and-stuff',
  'doers-get-more-done',
  'weekly-entertainment',
  'fashion-on-the-go',
  'no-days-off',
  'experience-thailand',
  'sleep',
  'baking-bread-guide',
  'sangria-artichoke',
  'ways-to-eat-avocado',
  'kitchen-stories',
  'album-releases',
  'almodos-films',
  'pizzas-in-nyc',
  '12-hours-in-barcelona',
  'ultimate-comparison',
  'fitness-apps-ranked',
  'street-style-on-the-go',
  'plant-based-dyes',
  'indoor-garden-oasis',
  'belly-fat-workout',
  'tv-show-recap',
  'pride-month-watchlist',
  'honeymooning-in-italy',
  'ace-hotel-kyoto-review',
  'how-video-calls-saved-the-day',
  'laptop-buying-guide',
  'diy-home-office',
  'kitchen-makeover',
  'self-care-guide',
  'rock-music-festival',
  'celebrity-q-and-a',
  'los-angeles-city-guide',
  'hawaii-travel-packing-list',
  'google-music-studio-tour',
  'how-contact-tracing-works',
  'summer-fashion-collection',
  'buying-art-on-the-internet',
  'house-hunting',
  'new-york-party-round-up',
  'a-day-in-the-life',
  'elegant-travel-itinerary',
  'modernist-travel-guide',
  'simple-tech-tutorial',
  'magazine-article',
  'fashion-inspiration',
  'skin-care-at-home',
  'art-books-gift-guide',
  'vintage-chairs-buying-guide',
  'celebrity-life-story',
  'series-best-of',
  'summer-adventure-guide',
  'one-day-city-itinerary',
  'technology-advice',
  'sustainability-tips',
  'an-artists-legacy',
  'tips-for-throwing-an-outdoor-luau',
  'all-about-cars',
];
